module.exports = __webpack_public_path__ + "img/bracket-6.a4eca7fb.svg";